import { render, staticRenderFns } from "./ExpandableConfig.vue?vue&type=template&id=c97f0892&scoped=true&"
import script from "./ExpandableConfig.vue?vue&type=script&lang=js&"
export * from "./ExpandableConfig.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableConfig.vue?vue&type=style&index=0&id=c97f0892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97f0892",
  null
  
)

export default component.exports